import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "../Button";
import {
  ExternalLink,
  Hamburger,
  HeaderMenu,
  HeaderSection,
  HeaderStyle,
  HeaderWrapper,
  Logo,
  Overlay,
  RecruitBtn,
  SearchBar,
  SearchBarWrapper,
  SearchToggle,
  SideMenu,
} from "./styled";

const searchIcon = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.7592 22.6908L19.2461 17.1777C20.5734 15.4108 21.2899 13.26 21.2875 11.05C21.2875 5.40508 16.6949 0.8125 11.05 0.8125C5.40508 0.8125 0.8125 5.40508 0.8125 11.05C0.8125 16.6949 5.40508 21.2875 11.05 21.2875C13.26 21.2899 15.4108 20.5734 17.1777 19.2461L22.6908 24.7592C22.9699 25.0086 23.3339 25.1418 23.708 25.1313C24.0822 25.1209 24.4382 24.9676 24.7029 24.7029C24.9676 24.4382 25.1209 24.0822 25.1313 23.708C25.1418 23.3339 25.0086 22.9699 24.7592 22.6908ZM3.7375 11.05C3.7375 9.60372 4.16637 8.18993 4.96988 6.98739C5.77339 5.78486 6.91544 4.8476 8.25163 4.29413C9.58781 3.74067 11.0581 3.59585 12.4766 3.87801C13.8951 4.16016 15.198 4.85661 16.2207 5.87928C17.2434 6.90195 17.9398 8.20492 18.222 9.6234C18.5041 11.0419 18.3593 12.5122 17.8059 13.8484C17.2524 15.1846 16.3151 16.3266 15.1126 17.1301C13.9101 17.9336 12.4963 18.3625 11.05 18.3625C9.11132 18.3602 7.25271 17.589 5.88185 16.2182C4.51099 14.8473 3.73983 12.9887 3.7375 11.05Z"
      fill="#1A1A1A"
    />
  </svg>
);
const Header = (props) => {
  const params = useLocation();
  const inputEl = useRef(null);
  const [menu_open, on_menu_open] = useState(0);
  const [search_open, on_search_open] = useState(0);
  const [search_input, update_search_input] = useState("");

  const ToggleMenu = () => {
    if (!menu_open) {
      on_menu_open(1);
    } else {
      on_menu_open(0);
    }
  };
  const ToggleSearch = () => {
    if (!search_open) {
      on_search_open(1);
      inputEl.current.focus();
    } else {
      on_search_open(0);
    }
  };
  const HandleSearch = (e) => {
    update_search_input(e.target.value);
    if (e.key === "Enter") {
      window.location.href = "/search/" + e.target.value;
    }
  };

  const [hide, setHide] = useState(false);
  const [pageY, setPageY] = useState(0);
  const documentRef = useRef(document);

  const handleScroll = () => {
    const { pageYOffset } = window;
    // const deltaY = pageYOffset - pageY;
    const hide = pageYOffset > 97 && pageY < pageYOffset;

    if (!menu_open) {
      setHide(hide);
      setPageY(pageYOffset);
    } else {
      setPageY(0);
    }
  };

  useEffect(() => {
    documentRef.current.addEventListener("scroll", handleScroll);
    return () =>
      documentRef.current.removeEventListener("scroll", handleScroll);
  });

  const [isHovered, setIsHovered] = useState(false);

  // useEffect(() => {
  //   const targetElement = document.getElementById("targett");
  //   if (isHovered) {
  //     targetElement.classList.add("hovered");
  //   } else {
  //     targetElement.classList.remove("hovered");
  //   }

  //   // Cleanup 함수로 컴포넌트 언마운트 시 클래스를 제거
  //   return () => {
  //     targetElement.classList.remove("hovered");
  //   };
  // }, [isHovered]);

  return (
    <HeaderStyle is_home={params.pathname == "/" ? "true" : ""}>
      <HeaderSection
        is_home={params.pathname == "/" ? "true" : ""}
        className={(hide ? "hide" : "") + (pageY < 97 ? " top" : "")}
      >
        <HeaderWrapper
          className="headerwrapper"
          id="targett"
          header_type={props.type}
          searchopen={search_open}
          is_home={params.pathname == "/" ? "true" : ""}
        >
          <a href="/">
            <Logo type={props.type}>
              <svg
                width="209"
                height="28"
                viewBox="0 0 209 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0)">
                  <path
                    d="M38.6671 14.37L38.3313 14.1527C37.1757 12.9972 35.556 12.4935 33.4029 12.6219C31.6053 12.7305 30.1831 13.4416 29.0966 14.1034C29.0966 14.0836 29.0966 14.0737 29.0966 14.054C29.0966 13.491 29.1559 12.8787 29.225 12.2861C29.2843 11.6836 29.3534 11.0713 29.3534 10.4885C29.3534 9.89595 29.2843 9.33299 29.0868 8.85891C29.0374 8.7404 28.9189 8.66138 28.7806 8.66138C28.1979 8.67126 27.062 9.0762 26.7954 9.31323L26.6472 9.63916C26.6373 10.2811 26.4991 12.0787 26.3509 12.296C26.3608 12.2861 26.2719 12.5132 26.2719 12.5132C26.025 15.0713 26.025 17.333 26.2522 19.2688C26.2818 19.4663 26.6472 19.7527 26.9336 19.8614C27.2497 19.9799 28.2374 19.7132 28.8102 19.496C28.8003 19.496 29.0275 19.4663 29.0275 19.4663C29.2053 19.4466 29.3139 19.2984 29.304 19.091L29.3139 18.5379C29.7287 16.8688 31.388 14.8737 33.3535 14.5774C34.4695 14.3997 35.3486 14.6861 36.0399 15.4466C36.1288 15.5848 36.3362 16.7799 35.6054 18.1626C35.0621 19.1898 33.9658 20.049 32.5337 20.5824C31.1707 21.096 29.6794 21.3034 27.8324 21.2441C27.7534 21.1947 26.104 20.0787 26.104 20.0787C24.6423 19.0515 22.825 17.7676 21.1756 17.1453C20.8891 17.0367 20.3657 16.6021 20.0496 16.3453L19.8817 16.2071C18.9336 15.4466 17.1162 14.2416 15.6644 13.2737C15.6644 13.2737 15.0125 12.8293 14.8841 12.7503C14.8841 12.691 14.8841 12.5824 14.8841 12.5824C14.9236 12.533 15.8422 11.9898 15.8422 11.9898C17.1163 11.2392 17.7088 10.8737 17.8372 10.6861C17.8076 10.7157 18.0051 10.5873 18.0051 10.5873C18.015 10.5774 21.1756 8.78978 21.1756 8.78978C24.2176 7.12064 27.6645 5.22435 29.472 3.3478L29.5608 3.06138L29.6003 2.80459C29.7189 2.39965 29.7287 2.09348 29.63 1.73793C29.6003 1.63916 29.5115 1.52064 29.3831 1.50089C27.9707 1.36262 26.1435 2.212 24.4842 3.76262C24.1089 4.1083 23.7929 4.28607 23.4669 4.46385L23.2101 4.60212C21.383 5.63916 17.2545 8.19718 15.1014 9.5799C15.2101 7.24904 15.6446 3.95027 16.1681 1.19472L16.1088 0.868789C16.099 0.858913 15.8817 0.453974 15.8817 0.453974L15.7138 0.157678L15.6644 0.147801C15.2298 -0.0694825 14.8841 0.0194064 14.6273 0.0786656L14.1928 0.23669L13.6298 0.444098C13.5211 0.463851 13.4323 0.532987 13.3927 0.651505C12.3656 3.14039 11.5063 7.23916 11.2989 10.5182C9.23468 9.20459 7.32848 8.25644 6.40007 7.80212L6.37044 7.79225L6.2618 7.76262C5.926 7.72311 5.51118 7.4762 5.12599 7.23916C5.0766 7.20953 4.33585 6.72558 4.33585 6.72558L3.14078 5.96509C3.15065 5.97496 2.82472 5.89595 2.82472 5.89595C2.31114 5.97496 1.32347 6.63669 1.02717 7.09101C0.997543 7.15027 0.977789 7.21941 0.977789 7.28854C0.977789 7.38731 1.00742 7.4762 1.03705 7.57496L1.08643 7.812L1.14569 7.96015C1.71854 8.55274 3.17041 9.53052 4.58277 10.291L6.2223 11.1601L8.74084 12.533C8.74084 12.5429 9.16554 12.8787 9.16554 12.8787L9.46184 13.0466C9.46184 13.0466 9.50135 13.0663 9.5211 13.0762C8.84949 13.5305 4.93833 16.1478 4.93833 16.1478L2.52842 17.7478C2.30126 17.9058 1.3531 18.3305 1.13582 18.4095C0.612353 18.6268 0.217286 18.9527 0.05926 19.3083L0 19.4367L0.0691366 19.5256L0.256793 19.6639C0.246916 19.6639 0.50371 19.8219 0.50371 19.8219L0.770379 19.9997C0.780256 19.9997 1.0173 20.0392 1.0173 20.0392C1.44199 20.0589 2.06422 19.812 3.23954 19.2984C4.3161 18.8243 7.23959 17.0564 8.49393 16.3058L9.02727 15.9898C9.24455 16.0095 9.49147 15.8219 9.70876 15.654C9.95567 15.4564 10.5088 15.1206 10.8347 14.9725C10.8446 14.9725 11.0322 14.8639 11.21 14.7651C11.21 14.8243 11.21 14.9034 11.21 14.9034C11.2693 18.7256 11.4866 21.5108 11.9014 23.654L11.9113 23.6935L11.9508 23.7824C12.1582 24.0885 12.3952 24.9873 12.6026 25.7873L13.0767 27.3873C13.0866 27.4071 13.215 27.5355 13.215 27.5355C13.4915 27.7231 14.3212 28.0392 14.8742 27.97L15.0125 27.9503L15.1014 27.7527C15.1508 27.5157 15.1607 27.2787 15.1607 27.0219C15.1607 26.7256 15.1409 26.4095 15.1113 26.0145L15.0718 25.4416C14.894 22.775 14.7261 18.9132 14.7261 16.3453C14.7261 16.2762 14.7261 16.2071 14.7261 16.1379C15.1804 16.4243 17.1656 17.6688 17.1656 17.6688C20.5434 19.8614 25.6497 23.17 28.7312 24.049C28.8892 24.0984 29.0571 24.0589 29.1757 23.9503C29.1757 23.9404 29.6497 23.6441 29.6497 23.6441L29.7386 23.6046C29.9164 23.5157 30.0349 23.2194 30.0547 22.9034C32.6522 22.775 36.277 21.7676 38.2227 19.328C38.9733 18.3799 39.3091 17.2243 39.3091 16.2367C39.2992 15.4564 39.0721 14.7552 38.6671 14.37Z"
                    fill="#FFBC00"
                  />
                  <path
                    d="M68.8501 3.92078H78.2033C82.6577 3.92078 84.9787 5.39238 84.9787 8.63189C84.9787 10.9331 83.3787 12.5134 81.2354 12.9381V13.0171C84.2972 13.3825 85.749 15.3874 85.749 17.659C85.749 20.5035 83.6651 22.9627 78.4996 22.9627H68.8501V3.92078ZM71.8822 11.9405H78.0551C80.3465 11.9405 82.0453 11.0714 82.0453 9.0467C82.0453 7.2788 81.2058 6.09362 77.7095 6.09362H71.8822V11.9405ZM71.8822 20.7899H77.8675C81.5811 20.7899 82.5688 19.3381 82.5688 17.4911C82.5688 15.3084 81.0576 14.0936 77.7095 14.0936H71.8822V20.7899Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M48.2573 3.92078H51.2993V12.4344L61.5316 3.92078H65.8378L55.0228 12.5134L66.7366 22.9529H62.4303L51.2993 12.7504V22.9529H48.2573V3.92078Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M134.451 14.1332V11.2098H142.648V9.16531H134.451V6.27148H143.132V4.21716H132.09V16.1875H143.607V14.1332H134.451Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M145.957 22.9135H148.357V11.1308H150.797V9.04681H148.357V3.80237H145.957V22.9135Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M93.2555 6.27148H100.051V4.21716H90.895V15.7135H100.525V13.6591H93.2555V6.27148Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M102.421 8.85907H98.6582V10.9331H102.421V22.2912H104.742V3.72327H102.421V8.85907ZM106.066 22.9134H108.387V3.72327H106.066V22.9134Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M129.078 3.80237H126.678V22.9135H129.078V3.80237Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M117.73 14.479C115.419 14.479 113.552 13.1655 113.552 10.2124C113.552 7.27903 115.419 5.93582 117.73 5.93582C120.031 5.93582 121.898 7.27903 121.898 10.2124C121.898 13.1753 120.021 14.479 117.73 14.479ZM117.71 3.80249C114.006 3.80249 111.014 5.95558 111.014 10.3408C111.014 14.6864 114.016 16.879 117.71 16.879C121.404 16.879 124.406 14.6864 124.406 10.3408C124.416 5.95558 121.414 3.80249 117.71 3.80249Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M202.995 7.82203H200.743V9.89611H202.995V13.8566H205.316V3.72327H202.995V7.82203ZM206.64 13.8566H208.961V3.72327H206.64V13.8566Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M193.928 11.2986V9.69855H199.765V7.64423H193.928V6.08374H200.249V4.02942H191.568V13.343H200.714V11.2986H193.928Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M206.62 20.7602H196.022V17.1355H206.62V20.7602ZM209 15.0614H193.642V22.854H209V15.0614Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M190.244 19.358H171.212V21.4124H190.244V19.358Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M182.116 5.44182V3.86157H179.449V5.43194C179.005 11.4171 172.091 12.7702 172.111 12.7702V14.8344C174.866 14.311 178.689 12.6912 180.783 9.47145C182.876 12.6912 186.699 14.311 189.454 14.8344V12.7702C189.474 12.7801 182.56 11.4171 182.116 5.44182Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M169.296 3.80237H166.896V22.9135H169.296V3.80237Z"
                    fill="#1A1A1A"
                  />
                  <path
                    d="M159.508 7.32819V3.93066H156.891V7.32819C155.913 13.7479 151.626 14.7554 151.626 14.7554V16.7307C153.839 16.2665 156.673 14.0344 158.254 11.2393C160.002 14.0245 163.133 16.2665 165.335 16.7307V14.7554C165.335 14.7554 160.496 13.7381 159.508 7.32819Z"
                    fill="#1A1A1A"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="209" height="28" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </Logo>
          </a>

          <div className="shape" />

          <HeaderMenu header_type={props.type}>
            <ul className={params.pathname != "/" ? "sub" : ""}>
              <li
                className={
                  params.pathname == "/about" || params.pathname == "/about/"
                    ? "active"
                    : ""
                }
              >
                <a href={"/about"}>About</a>
                <ul className="sub_ul">
                  <li>
                    <a href="/about/#overview" className="submenu">
                      회사개요
                    </a>
                  </li>
                  <li>
                    <a href="/about/#business" className="submenu">
                      사업영역
                    </a>
                  </li>
                  <li>
                    <a href="/about/#esg" className="submenu">
                      지속가능경영활동
                    </a>
                  </li>
                  <li>
                    <a href="/about/#history" className="submenu">
                      연혁
                    </a>
                  </li>
                  <li>
                    <a href="/about/#youtube" className="submenu">
                      KBDS Youtube
                    </a>
                  </li>
                </ul>
              </li>

              <li
                className={
                  params.pathname == "/vision" || params.pathname == "/vision/"
                    ? "active"
                    : ""
                }
              >
                <a href={"/vision"}>Vision</a>
                <ul className="sub_ul">
                  <li>
                    <a href="/vision/#dx">DX</a>
                  </li>
                  <li>
                    <a href="/vision/#section_vision">영역별 비전</a>
                  </li>
                </ul>
              </li>

              <li
                className={
                  params.pathname == "/asset" || params.pathname == "/asset/"
                    ? "active"
                    : ""
                }
              >
                <a href={"/asset"}>Asset</a>
                <ul className="sub_ul">
                  <li>
                    <a href="/asset/#kbAddOneFramework">KB Add One Framework</a>
                  </li>
                  <li>
                    <a href="/asset/#kbImms">KB 통합유지보수 플랫폼</a>
                  </li>
                  <li>
                    <a href="/asset/#kbPms">KB플랜잇 프로젝트 관리시스템</a>
                  </li>
                  <li>
                    <a href="/asset/#liveCare">LiveCare 화상상담 시스템</a>
                  </li>
                  <li>
                    <a href="/asset/#kbIssueReporter">KB 이슈리포터</a>
                  </li>
                  <li>
                    <a href="/asset/#msp">통합 MSP 포털</a>
                  </li>
                </ul>
              </li>

              <li
                className={
                  params.pathname == "/people" || params.pathname == "/people/"
                    ? "active"
                    : ""
                }
              >
                <a href={"/people"}>People</a>
                <ul className="sub_ul">
                  <li>
                    <a href="/people/#focus">KBDS FOCUS</a>
                  </li>
                  <li>
                    <a href="/people/#live">KBDS Live</a>
                  </li>
                  <li>
                    <a href="/people/#wayworking">일하는 방식</a>
                  </li>
                  <li>
                    <a href="/people/#recruit">인재채용</a>
                  </li>
                </ul>
              </li>

              <li className={params.pathname == "/blog" ? "active" : ""}>
                <a target="_blank" href={"https://blog.kbds.co.kr/"}>
                  Blog
                </a>
              </li>
            </ul>

            <ExternalLink
              className="external"
              header_type={props.type}
              // onMouseEnter={() => setIsHovered(true)}
              // onMouseLeave={() => setIsHovered(false)}
            >
              <Button type="header" color="gray" icon="goodbye">
                <ul>
                  <li>
                    <a href="/global" target="_blank" rel="noreferrer">
                      Global
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/channel/UCFsYPVbeWWdg6zM7mDHpUJQ"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Youtube
                    </a>
                  </li>
                  {/* <li><a href="https://kbds.career.greetinghr.com/" target="_blank">Recruit</a></li> */}
                  <li>
                    <a
                      href="https://econ.kds.co.kr"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Partner
                    </a>
                  </li>
                </ul>
              </Button>
            </ExternalLink>
            <RecruitBtn
              className="recruite"
              href="https://kbds.career.greetinghr.com/"
              target="_blank"
            >
              Recruit
            </RecruitBtn>
            <SearchToggle
              onClick={ToggleSearch}
              searchopen={search_open}
              search_type={props.type}
            >
              {searchIcon}
            </SearchToggle>
            <Hamburger
              onClick={ToggleMenu}
              isopen={menu_open}
              color={props.type}
            >
              <div>
                <i className="l" />
                <i className="s" />
                <i className="l" />
              </div>
            </Hamburger>
          </HeaderMenu>

          <SideMenu isopen={menu_open}>
            <ul className={params.pathname != "/" ? "sub" : ""}>
              <li className={params.pathname == "/about" ? "active" : ""}>
                <a href={"/about"}>About</a>
              </li>

              <li className={params.pathname == "/vision" ? "active" : ""}>
                <a href={"/vision"}>Vision</a>
              </li>

              <li className={params.pathname == "/asset" ? "active" : ""}>
                <a href={"/asset"}>Asset</a>
              </li>

              <li className={params.pathname == "/people" ? "active" : ""}>
                <a href={"/people"}>People</a>
              </li>

              <li className={params.pathname == "/blog" ? "active" : ""}>
                <a target="_blank" href={"https://blog.kbds.co.kr/"}>
                  Blog
                </a>
              </li>

              <li className="acc a-cc">
                <a
                  href="https://kbds.career.greetinghr.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Recruit{" "}
                  <img
                    src={
                      "https://wp.daitso.kds.co.kr/wp-content/plugins/ep-manager/assets/images/common/NavArrowGray.png"
                    }
                    alt=""
                  />{" "}
                </a>
              </li>

              <li className="acc">
                <a
                  href="https://econ.kds.co.kr"
                  target="_blank"
                  rel="noreferrer"
                >
                  Partner{" "}
                  <img
                    src={
                      "https://wp.daitso.kds.co.kr/wp-content/plugins/ep-manager/assets/images/common/NavArrowGray.png"
                    }
                    alt=""
                  />
                </a>
              </li>

              <li className="acc">
                <a href="/global" target="_blank" rel="noreferrer">
                  Global{" "}
                  <img
                    src={
                      "https://wp.daitso.kds.co.kr/wp-content/plugins/ep-manager/assets/images/common/NavArrowGray.png"
                    }
                    alt=""
                  />
                </a>
              </li>
            </ul>
          </SideMenu>
        </HeaderWrapper>

        <SearchBarWrapper searchopen={search_open}>
          <SearchBar searchopen={search_open}>
            <input
              className="search__input"
              searchopen={search_open}
              onKeyPress={(e) => HandleSearch(e)}
              type="text"
              placeholder="Search"
              ref={inputEl}
            />
            <div className="close" onClick={ToggleSearch}>
              <div></div>
              <div></div>
            </div>
          </SearchBar>
          <Overlay searchopen={search_open} onClick={ToggleSearch}></Overlay>
        </SearchBarWrapper>
      </HeaderSection>
    </HeaderStyle>
  );
};

export default Header;
